import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ADMIN_EMAIL = "ignacioglezdiaz@gmail.com";

/**
 * Route guard that only allows the configured admin to see `children`.
 * Non-admin users are redirected to `fallback`.
 * While auth is loading we render nothing to avoid a flash.
 */
export default function AdminOnly({ children, fallback = "/" }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    const isAdmin =
        user && typeof user === "object"
        && (user.email || "").toLowerCase() === ADMIN_EMAIL;
    if (!isAdmin) return <Navigate to={fallback} replace />;
    return children;
}
